import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../../../../services/common';
import { Users, UsersCategory } from '../allotment-addupdate.model';
import { FormGroup } from '@angular/forms';
import { SalesService } from '../../../sales.service';

@Component({
  selector: 'app-address-details',
  templateUrl: './address-details.component.html',
  styleUrl: './address-details.component.scss'
})
export class AddressDetailsComponent implements OnInit{

  usersCategory: UsersCategory[] | undefined;
  selectedCategory: UsersCategory | undefined;
  users: Users[] | undefined;
  selectedUser: Users | undefined;
  allotmentForm!: FormGroup<any>;
  constructor(
    public commonService:CommonService,
    public salesService:SalesService
  ){

  }

  ngOnInit(): void {

  }
}
